import { createSlice } from '@reduxjs/toolkit';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
    FETCH_FILTER_ATTACHMENTS,
    FETCH_FILTER_ATTACHMENTS_FAILURE,
    FETCH_FILTER_ATTACHMENTS_SUCCESS,
    SAVE,
    SAVE_FAILURE,
    SAVE_SUCCESS,
    SET_FILTER_DATA,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    bulkUpdateItems: {
        errors: null,
        isFetching: false,
    },
    filterData: {},
    filterAttachments: {
        data: {
            data: [],
            paginaton: {},
        },
        errors: [],
        isFetching: false,
    },
    save: {
        isSaving: false,
        data: {},
        errors: null,
    },
};

const attachmentsSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [BULK_UPDATE_ITEMS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: [],
                isFetching: true,
            };
        },
        [BULK_UPDATE_ITEMS_FAILURE]: (state, action) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: action.payload,
                isFetching: false,
            };
        },
        [BULK_UPDATE_ITEMS_SUCCESS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                isFetching: false,
            };
        },
        [FETCH_FILTER_ATTACHMENTS]: (state, action) => {
            state.filterAttachments = {
                ...state.filterAttachments,
                query: action.payload,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_FILTER_ATTACHMENTS_FAILURE]: (state, action) => {
            state.filterAttachments = {
                ...state.filterAttachments,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_FILTER_ATTACHMENTS_SUCCESS]: (state, action) => {
            state.filterAttachments = {
                ...state.filterAttachments,
                data: action.payload,
                isFetching: false,
            };
        },
        [SAVE]: (state) => {
            state.save = {
                ...state.save,
                errors: [],
                isSaving: true,
            };
        },
        [SAVE_FAILURE]: (state, action) => {
            state.save = {
                ...state.save,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_SUCCESS]: (state) => {
            state.save = {
                ...state.save,
                isSaving: false,
            };
        },
        [SET_FILTER_DATA]: (state, action) => {
            state.filterData = action.payload;
        },
    },
});

export const attachmentsActions = attachmentsSlice.actions;

export default attachmentsSlice.reducer;
